<div class="card">
  <div class="card-header">
    <strong>รายงานผลการตรวจสอบ</strong>
  </div>
  <div class="card-body">
    <form #form="ngForm" class="form-validate" (ngSubmit)="submit()">
      <div class="row mb-3">
        <div class=" col-xl-12">
          <label class="ui-require"><strong>หนังสือนำส่งรายการตรวจสอบข้อมูล</strong></label>
        </div>
        <div class="col-12 mt-2 mb-3">
          <app-file-upload [name]="'submission-letter'"
                           [size]="'normal'"
                           [(ngModel)]="request.letterFile" [id]="'submission-letter'"></app-file-upload>
          <gt-error [field]="'letterFile'"></gt-error>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-xl-12">
          <label class="ui-require"><strong>ไฟล์ข้อมูลผลการตรวจสอบ</strong></label>
        </div>
        <div class="col-xl-12">
          <span>หมายเหตุ :</span>
          <ol>
            <li>กรณี พบพลการ ให้ใช้ไฟล์ excel เดียวกับต้นฉบับและลบข้อมูลที่ไม่พลการออก</li>
            <li>กรณี ไม่พบพลการ ให้ใช้ไฟล์ excel เดียวกับต้นฉบับและลบข้อมูลที่ไม่พลการออกทั้งหมด
              จะคงเหลือเฉพาะหัวคอลัมน์
            </li>
          </ol>
        </div>
        <div class="col-12 mt-2 mb-2">
          <div class="custom-file">
            <app-file-upload [name]="'audit'"
                             #auditFile
                             (uploaded)="prepareArbitrary($event)"
                             [size]="'normal'"
                             [(ngModel)]="request.auditFile" [id]="'audit'"></app-file-upload>
            <gt-error [code]="'SrmHospitalArbitraryReportDtoValidator'"></gt-error>
            <gt-error [code]="'AllowContentTypeExcel'"></gt-error>
          </div>
        </div>
      </div>
      @if (result) {
        <div class="row mb-3">
          <div class="col-xl-12 mt-3">
            <p [ngClass]="{'text-danger': !result?.valid}">{{ result.result }}</p>
          </div>
          @if (result?.valid) {
            <div class="col-xl-12">
              <p>ประเภทรายงาน : {{ ARBITRARY_TYPE(result.arbitraryType) }}</p>
            </div>
            <div class="col-xl-12">
              <p>{{ result?.hmainOp?.province?.zone?.name }}  หน่วยบริการ
                : {{ result?.hmainOp?.hcode }} {{ result?.hmainOp?.hname }}</p>
            </div>
            <div class="col-xl-12">
              <p>รอบการแจ้งเตือน : {{ result?.round }}</p>
            </div>
          }
        </div>
      }
      <div class="row mt-3 mb-3">
        <div class="col-xl-12">
          <label for="remark"><strong>หมายเหตุ</strong></label>
          <textarea type="text" class="form-control"
                    rows="5"
                    [(ngModel)]="request.remark"
                    id="remark" name="remark"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="offset-xl-2 col-xl-10">
          <button [disabled]="!result" type="submit" class="btn btn-success me-2">
            บันทึก
          </button>
          <button class="btn btn-secondary app-btn" type="reset">
            ยกเลิก
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
